__turbopack_context__.v({
  "allMenuAlignment": "header-module__iAz9oa__allMenuAlignment",
  "calcButton": "header-module__iAz9oa__calcButton",
  "calcDropdownPanel": "header-module__iAz9oa__calcDropdownPanel",
  "calcDropdownPanelOpen": "header-module__iAz9oa__calcDropdownPanelOpen",
  "calcDropdownTitle": "header-module__iAz9oa__calcDropdownTitle",
  "calcDropdownTrigger": "header-module__iAz9oa__calcDropdownTrigger",
  "calcDropdownWrap": "header-module__iAz9oa__calcDropdownWrap",
  "calcGrid": "header-module__iAz9oa__calcGrid",
  "categoriseRelativeDiv": "header-module__iAz9oa__categoriseRelativeDiv",
  "dropdownDesign": "header-module__iAz9oa__dropdownDesign",
  "dropdownDesignClose": "header-module__iAz9oa__dropdownDesignClose",
  "dropdownDesignOpen": "header-module__iAz9oa__dropdownDesignOpen",
  "headerAlignment": "header-module__iAz9oa__headerAlignment",
  "headerAlignmentMinimal": "header-module__iAz9oa__headerAlignmentMinimal",
  "headerContainer": "header-module__iAz9oa__headerContainer",
  "headerContainerMinimal": "header-module__iAz9oa__headerContainerMinimal",
  "headerCtaPrimary": "header-module__iAz9oa__headerCtaPrimary",
  "headerLogo": "header-module__iAz9oa__headerLogo",
  "headerLogoMinimal": "header-module__iAz9oa__headerLogoMinimal",
  "headerSearchWrap": "header-module__iAz9oa__headerSearchWrap",
  "headerSiteName": "header-module__iAz9oa__headerSiteName",
  "langDropdownItem": "header-module__iAz9oa__langDropdownItem",
  "langDropdownItemActive": "header-module__iAz9oa__langDropdownItemActive",
  "langDropdownMenu": "header-module__iAz9oa__langDropdownMenu",
  "langDropdownMenuOpen": "header-module__iAz9oa__langDropdownMenuOpen",
  "langDropdownTrigger": "header-module__iAz9oa__langDropdownTrigger",
  "langDropdownWrap": "header-module__iAz9oa__langDropdownWrap",
  "logo": "header-module__iAz9oa__logo",
  "menuSearch": "header-module__iAz9oa__menuSearch",
  "menuText": "header-module__iAz9oa__menuText",
  "mobileHeaderHidden": "header-module__iAz9oa__mobileHeaderHidden",
  "mobileHeaderShow": "header-module__iAz9oa__mobileHeaderShow",
  "mobileLangDropdown": "header-module__iAz9oa__mobileLangDropdown",
  "mobileLangLabel": "header-module__iAz9oa__mobileLangLabel",
  "mobileLangOption": "header-module__iAz9oa__mobileLangOption",
  "mobileLangOptionActive": "header-module__iAz9oa__mobileLangOptionActive",
  "mobileLangOptions": "header-module__iAz9oa__mobileLangOptions",
  "mobileMenu": "header-module__iAz9oa__mobileMenu",
  "mobileViewBodyContentAlignment": "header-module__iAz9oa__mobileViewBodyContentAlignment",
  "mobileViewHeader": "header-module__iAz9oa__mobileViewHeader",
  "mobileViewMoreLink": "header-module__iAz9oa__mobileViewMoreLink",
  "mobileViewMoreLinks": "header-module__iAz9oa__mobileViewMoreLinks",
  "mobileViewSearch": "header-module__iAz9oa__mobileViewSearch",
  "mobileViewSearchWrap": "header-module__iAz9oa__mobileViewSearchWrap",
  "mobileViewallMenuAlignment": "header-module__iAz9oa__mobileViewallMenuAlignment",
  "mobileViewcategoriseRelativeDiv": "header-module__iAz9oa__mobileViewcategoriseRelativeDiv",
  "mobileViewdropdownDesign": "header-module__iAz9oa__mobileViewdropdownDesign",
  "mobileViewdropdownDesignClose": "header-module__iAz9oa__mobileViewdropdownDesignClose",
  "mobileViewdropdownDesignOpen": "header-module__iAz9oa__mobileViewdropdownDesignOpen",
  "mobileViewrelativMainDiv": "header-module__iAz9oa__mobileViewrelativMainDiv",
  "profileImage": "header-module__iAz9oa__profileImage",
  "profiledropdown": "header-module__iAz9oa__profiledropdown",
  "profiledropdownDesgin": "header-module__iAz9oa__profiledropdownDesgin",
  "relativMainDiv": "header-module__iAz9oa__relativMainDiv",
  "searchBarCenterAlignment": "header-module__iAz9oa__searchBarCenterAlignment",
  "searchIconAlignment": "header-module__iAz9oa__searchIconAlignment",
  "searchLoadingPlaceholder": "header-module__iAz9oa__searchLoadingPlaceholder",
  "searchbar": "header-module__iAz9oa__searchbar",
  "smallHeaderAlignment": "header-module__iAz9oa__smallHeaderAlignment",
  "userproifleDetailscontent": "header-module__iAz9oa__userproifleDetailscontent",
});
